// material
import { useTheme } from '@material-ui/core/styles';
import { Box, Stack, Divider } from '@material-ui/core';
// components

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function DashboardFooter() {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const logoSrc = isDark ? '/static/pac-logo-white.svg' : '/static/pac-logo-black.svg';

  return (
    <Box pt={2}>
      <Divider />
      <Stack justifyContent="center" alignItems="center">
        <Box p={1}>
          <Box component="img" src={logoSrc} sx={{ height: 15 }} />
        </Box>
      </Stack>
    </Box>
  );
}
